import React from 'react';
import OnboardingPage, { OnboardingPageProps } from '../../../components/OnboardingPage';

const AdditionalInfoScreen = (props: OnboardingPageProps) => <OnboardingPage {...props} />;

export default AdditionalInfoScreen;
